import apiClient, { unwrap } from './client'
import type { Domain } from './types'

export const domainsApi = {
  list() {
    return unwrap<Domain[]>(apiClient.get('/domains'))
  },

  create(data: {
    name: string
    description?: string
    max_quota_bytes?: number
    max_users?: number
    default_forward_email?: string | null
    helo_domain?: string | null
  }) {
    return unwrap<{ id: number }>(apiClient.post('/domains', data))
  },

  get(id: number) {
    return unwrap<Domain>(apiClient.get(`/domains/${id}`))
  },

  update(id: number, data: {
    name: string
    description?: string | null
    max_quota_bytes?: number | null
    max_users?: number | null
    default_forward_email?: string | null
    helo_domain?: string | null
  }) {
    return unwrap<{ updated: boolean }>(apiClient.put(`/domains/${id}`, data))
  },

  delete(id: number) {
    return unwrap<{ deleted: boolean }>(apiClient.delete(`/domains/${id}`))
  },
}
